import validation from '@/plugins/validation'
import '@/style/main.scss'
import '@morev/vue-transitions/styles'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import duration from 'dayjs/plugin/duration'
import relativeTime from 'dayjs/plugin/relativeTime'
import JoditVue from 'jodit-vue'
import { createPinia, PiniaVuePlugin } from 'pinia'
import Vue from 'vue'
import VueGtag from 'vue-gtag'
import VueHtmlToPaper from 'vue-html-to-paper'
import ViaCep from 'vue-viacep'
import App from './App.vue'
import './assets/tailwind.css'
import './assets/transitions.css'
import api from './plugins/api'
import eventBus from './plugins/eventBus'
import logger from './plugins/logger'
import moment from './plugins/moment'
import util, { util as utilFunctions } from './plugins/util'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import { isRequestAborted } from './utils/error'
import { EventBusInjectionKey, ViaCepInjectionKey } from './utils/injection-keys'
import Clarity from '@microsoft/clarity'

dayjs.locale('pt-br')
dayjs.extend(customParseFormat)
dayjs.extend(duration)
dayjs.extend(relativeTime)

Vue.config.productionTip = false

document.getElementById('favicon').href = utilFunctions.faviconPerDomain(location.hostname)

Clarity.init(process.env.VUE_APP_CLARITY_PROJECT_ID)

Vue.use(PiniaVuePlugin)
Vue.use(PiniaVuePlugin)
Vue.use(ViaCep)
Vue.use(JoditVue)
Vue.use(validation)
Vue.use(util)
Vue.use(api)
Vue.use(logger)
Vue.use(moment)
Vue.use(eventBus)
Vue.use(VueHtmlToPaper, {
  name: '_blank',
  specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
})

if (process.env.NODE_ENV !== 'development') {
  Vue.use(VueGtag, {
    config: { id: `${process.env.VUE_APP_GOOGLE_TAG_ID}` },
  })
}

Vue.filter('emptyValue', (str) => str || '---')

Vue.component('FormNode', require('@/components/NewAttendanceForm/FormNodes/FormNode.vue').default)

new Vue({
  router,
  store,
  vuetify,
  pinia: createPinia(),
  render: (h) => h(App),
  provide: {
    [EventBusInjectionKey]: Vue.prototype.$eventBus,
    [ViaCepInjectionKey]: Vue.prototype.$viaCep,
  },
  data: {
    appVersion: process.env.VUE_APP_VERSION,
    appName: process.env.VUE_APP_NAME,
    alertComponent: null,
    confirmComponent: null,
    snackbarComponent: null,
  },
  methods: {
    async confirm(message) {
      try {
        return await this.confirmComponent.confirm(message)
      } catch (error) {
        this.$logger.warn(error)
      }
    },
    info(message, title, actionTitle, actionFunction, prependIcon) {
      this.$logger.info(message)
      this.alertComponent.show('info', {
        title,
        description: message,
        action:
          actionTitle && actionFunction
            ? {
                text: actionTitle,
                fn: actionFunction,
              }
            : undefined,
        icon: prependIcon,
      })
    },
    error(error, title, actionTitle, actionFunction, prependIcon) {
      this.$logger.error(error)
      if (isRequestAborted(error)) {
        return
      }
      const errorMessage = error instanceof Error ? error.message : error
      this.alertComponent.show('error', {
        message: title ?? errorMessage,
        description: title ? errorMessage : undefined,
        action:
          actionTitle && actionFunction
            ? {
                text: actionTitle,
                fn: actionFunction,
              }
            : undefined,
        icon: prependIcon,
      })
    },
    warn(message, title, actionTitle, actionFunction, prependIcon) {
      this.$logger.warn(message)
      this.alertComponent.show('warning', {
        title,
        description: message,
        action:
          actionTitle && actionFunction
            ? {
                text: actionTitle,
                fn: actionFunction,
              }
            : undefined,
        icon: prependIcon,
      })
    },
    ok(message, title, actionTitle, actionFunction, prependIcon) {
      this.alertComponent.show('success', {
        title,
        description: message,
        action:
          actionTitle && actionFunction
            ? {
                text: actionTitle,
                fn: actionFunction,
              }
            : undefined,
        icon: prependIcon,
      })
    },
    notify(message) {
      this.notificationComponent.show(message)
    },
    snackbar(timeout, text, action) {
      this.snackbarComponent.show(timeout, text, action)
    },
  },
}).$mount('#app')
